import React from 'react'
import { VendorStateLabels } from 'src/pages/Vendors/vendors.constants'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const VendorStateFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const filterValues = Object.values(VendorStateLabels).map(
      (label: VendorStateLabels) => ({
        value: label,
        label: label,
      }),
    )

    return (
      <FilterDropdown
        filterParam={FilterParam.VENDOR_STATE}
        filterName={FilterName.VENDOR_STATE}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
